import { ECurrentRegionActions } from '../../actions/currentRegion';
import { TCurrentRegion } from '../../types/currentRegion';
import { TReduxActions } from '../../types/redux';

export const defaultState: TCurrentRegion = {
  id: -1,
  displayName: 'Москва и область',
};

export function currentRegionReducer(state: TCurrentRegion = defaultState, action: TReduxActions): TCurrentRegion {
  switch (action.type) {
    case ECurrentRegionActions.Set:
      return action.payload;
    default:
      return state;
  }
}
